// Auto-generated from octomil-contracts. Do not edit.

export enum DeviceClass {
  Flagship = "flagship",
  High = "high",
  Mid = "mid",
  Low = "low",
}
